<template lang="pug">
EatView
  div.flex-grow-1.d-flex.flex-column(v-scrollable="true" :id="`${Saletype.DIGITAL_MENU}-order-scrollable`")
    div#order-scroll-trigger.flex-shrink-0
      LocationInfo.bg-neutral-a

    Menu.bg-neutral-a.d-flex.flex-column.flex-grow-1(:readonly="true" :saletype="Saletype.DIGITAL_MENU")

    div.pa-5.text-center.bg-neutral-a.mt-auto(v-if="app")
      a.text-decoration-underline.ml-1(:href="app.urlPrivacyPolicy" target="_self" @click.stop) {{ $t('order.privacyPolicyLink') }}
      span {{ $t("general.and") }}
      a.text-decoration-underline.ml-1(:href="app.urlTermsOfSales" @click.stop) {{ $t('order.termsOfSalesLink') }}

  ProductDetail(:readonly="true")
</template>

<script setup lang="ts">
import LocationInfo from "@/views/order/partials/LocationInfo.vue";
import Menu from "@/views/order/partials/Menu.vue";
import ProductDetail from "@/components/menuProduct/ProductDetail.vue";
import { Saletype } from "@/models/App";
import { useApp } from "@/store/app";
import { setAppTitle } from "@/store/appTitle";
import { useI18n } from "vue-i18n";

const i18n = useI18n();
setAppTitle(i18n.t("order.appTitle").toString());

const { app } = useApp();
</script>

<style lang="scss" scoped>
.scroll-snap-container {
  scroll-snap-type: y proximity;
}
.scroll-snap {
  scroll-snap-align: start;
}

.date-time-picker__saletype {
  text-transform: capitalize;
}
.gradient-border-bottom {
  height: 2px;
  background: linear-gradient(226deg, rgba(197, 245, 49, 1) 10%, rgba(0, 113, 242, 1) 92%);
}
</style>
